
// 格子类型
export const FONT_SIZE_LIST = [  
  { label: '10px', value: '10' },
  { label: '11px', value: '11' },
  { label: '12px', value: '12' },
  { label: '13px', value: '13' },
  { label: '14px', value: '14' },
  { label: '15px', value: '15' },
  { label: '16px', value: '16' },
  { label: '17px', value: '17' },
  { label: '18px', value: '18' },
  { label: '19px', value: '19' },
  { label: '21px', value: '21' },
  { label: '22px', value: '22' },
  { label: '23px', value: '23' },
  { label: '24px', value: '24' },
  { label: '25px', value: '25' },
  { label: '26px', value: '26' },
  { label: '27px', value: '27' },
  { label: '28px', value: '28' },
  { label: '29px', value: '29' },
  { label: '30px', value: '30' }  
];